<template>
  <div class="public-notify" v-if="isShow">
    <div role="alert" class="el-notification right" style="bottom: 16px; z-index: 2009">
      <div class="el-notification__group">
        <div class="el-notification__closeBtn el-icon-close" @click="onClose"></div>
        <h2 class="el-notification__title">
          <I18Lang id="public65" defaultText="提示" />
        </h2>
        <div class="el-notification__content">
          <div class="not-item" @click="goRouter('proxyAgentDeposit')" v-if="noticeData.agentRechargeAuditNum > 0">
            <I18Lang id="public66" defaultText="代理入金待审批" />（{{ noticeData.agentRechargeAuditNum }}）
          </div>
          <div class="not-item" @click="goRouter('proxyCustomerDeposit')" v-if="noticeData.userRechargeAuditNum > 0">
            <I18Lang id="public67" defaultText="用户入金待审批" />（{{ noticeData.userRechargeAuditNum }}）
          </div>
          <div class="not-item" @click="goRouter('proxyAuditWithdrawal')" v-if="noticeData.agentWithdrawalAuditNum > 0">
            <I18Lang id="public68" defaultText="代理出金待审批" />（{{ noticeData.agentWithdrawalAuditNum }}）
          </div>
          <div class="not-item" @click="goRouter('proxyCustomerWithdrawal')" v-if="noticeData.userWithdrawalAuditNum > 0">
            <I18Lang id="public69" defaultText="用户出金待审批" />（{{ noticeData.userWithdrawalAuditNum }}）
          </div>
          <div class="not-item" @click="goRouter('proxyCustomerList')" v-if="noticeData.authUserNum > 0">
            <I18Lang id="public70" defaultText="用户资料审批" />（{{ noticeData.authUserNum }}）
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'PublicNotify',
  data () {
    return {
      isShow: false,
      noticeData: {
        agentRechargeAuditNum: 0,
        userRechargeAuditNum: 0,
        agentWithdrawalAuditNum: 0,
        userWithdrawalAuditNum: 0,
        userDetailAuditNum: 0,
        authUserNum: 0
      },
      startTime: ''
    }
  },
  mounted () {
    this.startTimeout(3000)
  },
  destroyed () {
    this.startTime && clearInterval(this.startTime)
  },
  methods: {
    goRouter (name) {
      this.$router.push({ name: name })
    },
    onClose () {
      this.isShow = false
      this.startTime && clearInterval(this.startTime)
      this.startTimeout(1000 * 60 * 10)
    },
    startTimeout (time) {
      this.startTime = setTimeout(() => {
        this.getNotices()
      }, time)
    },
    getNotices () {
      this.$http.get('/api/user/notices', { loading: false }).then((result) => {
        // agentRechargeAuditNum（代理入金待审核数量）、userRechargeAuditNum（用户入金待审核数量）、
        // agentWithdrawalAuditNum（代理出金待审核数）、userWithdrawalAuditNum（用户出金待审核数）
        // authUserNum（用户资料待审批数）
        if (result) {
          result.map((item) => {
            if (Object.keys(this.noticeData).includes(item.module)) {
              this.noticeData[item.module] = item.num
            }
          })
        }
        if (
          this.noticeData.agentRechargeAuditNum > 0 ||
          this.noticeData.userRechargeAuditNum > 0 ||
          this.noticeData.agentWithdrawalAuditNum > 0 ||
          this.noticeData.userWithdrawalAuditNum > 0 ||
          this.noticeData.authUserNum > 0
        ) {
          this.isShow = true
        } else {
          this.isShow = false
          this.startTime && clearInterval(this.startTime)
          this.startTimeout(1000 * 20)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.public-notify {

  .el-notification {
    width: 450px !important;
    min-height: 397px;
    height: auto;
    background: url("../../assets/img/dialog-bg/notification-bg.png") no-repeat center / 100% 100%;
    padding-bottom: 30px;
    border: none;

    .el-notification__title {
      font-size: 20px;
      font-family: Arial;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 25px;
      padding-top: 15px;
      padding-left: 20px;
    }

    .el-notification__closeBtn {
      width: 54px;
      height: 26px;
      margin-top: 15px;
      margin-right: 10px;
      transition: 0.5s all;
      background: url("../../assets/img/btn/xnor.png") no-repeat center / 100% 100%;

      i {
        display: none;
      }

      &:hover {
        background: url("../../assets/img/btn/xhov.png") no-repeat center / 100% 100%;
      }

      &::before {
        display: none;
      }
    }

    .el-notification__group {
      margin-right: 0;
    }

    .el-notification__content {
      padding-top: 30px;

      .not-item {
        cursor: pointer;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 56px;
        display: flex;
        align-items: center;
        padding-left: 8px;

        &::before {
          content: '';
          width: 21px;
          height: 33px;
          display: block;
          background: url("../../assets/img/dialog-bg/arrow-jt.png") no-repeat center / 100% 100%;
        }
      }
    }
  }
}
</style>
